"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    imageWrapper: {
      background: (0, _colorManipulator.alpha)((_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.primary) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main, 0.1),
      height: "100%",
      position: "relative",
      width: "100%"
    },
    image: {
      left: "50%",
      maxHeight: "60%",
      maxWidth: "60%",
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  };
});
var _default = exports.default = styles;